import { render } from "./MiniPlotPreview.vue?vue&type=template&id=c33612a2&scoped=true"
import script from "./MiniPlotPreview.vue?vue&type=script&lang=js"
export * from "./MiniPlotPreview.vue?vue&type=script&lang=js"

import "./MiniPlotPreview.vue?vue&type=style&index=0&id=c33612a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33612a2"]])

export default __exports__